import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import { omit } from "lodash";

const initial_value = {
  event_id: "",
  name: "",
  services: [],
};

const animatedComponents = makeAnimated();

let myModal = {};

export default function ModalViewEvent(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [save_data, SetSaveData] = useState(initial_value);
  const [service_data, SetServiceData] = useState([]);

  const [errors, setErrors] = useState({});
  const [is_read_only, SetIsReadOnaly] = useState(true);
  // const [brand_id, SetBrandId] = useState(7);
  // const [outlet_id, SetOutletId] = useState(13);
  const [id_value, SerIdValue] = useState(useParams());

  useEffect(() => {
    console.log("ModalViewEvent On mount :", props);
    let myModal1 = document.getElementById("ViewEventModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("hide event close_data :", close_data);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.data.is_open) {
      console.log("ModalViewEvent On mount :", props);
      get_event_init();
      let props_service = [];
      if (props.data.record.services != undefined) {
        props.data.record.services.map((s_item, s_index) => {
          let v_data = {
            id: s_item.service_id,
            quantity: s_item.quantity,
          };
          props_service.push(v_data);
        });
      }
      let value_data = {
        event_id: props.data.record.id,
        name: props.data.record.name,
        services: props_service,
      };

      console.log("value_data :", value_data);
      SetSaveData(value_data);
      if (props.data.type == "view") {
        SetIsReadOnaly(true);
      } else {
        SetIsReadOnaly(false);
      }
      myModal = new bootstrap.Modal(
        document.getElementById("ViewEventModal"),
        {}
      );
      myModal.show();
    }
  }, [props.data.is_open]);

  async function get_event_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
    };
    let response = await api("/brand/create_event_init", pass_data);
    console.log("create_event_init response :", response);

    let service_value = response.response.services;
    let selected_service = props.data.record.services;
    let si_array = [];
    if (selected_service != undefined) {
      selected_service.map((ss_item, ss_index) => {
        service_value.map((sv_item, sv_index) => {
          if (sv_item.id == ss_item.service_id) {
            si_array.push(sv_item);
          }
        });
      });
    }

    service_value.map((item) => {
      item.checked = false;
      if (si_array.length > 0) {
        for (var i = 0; i < si_array.length; i++) {
          if (si_array[i].id == item.id) {
            item.checked = true;
            item.count_value = props.data.record.services[i].quantity;
          }
        }
      }
    });
    SetServiceData(service_value);
    console.log("Save Data :", save_data);
  }

  function onServiceChange(item: any, index: any) {
    SetServiceData((prevValue) => {
      prevValue[index].checked = !prevValue[index].checked;
      if (prevValue[index].checked) {
        SetSaveData((prevValue) => {
          let add_data = {
            id: item.id,
            quantity: "",
          };
          prevValue.services.push(add_data);
          return { ...prevValue };
        });
      } else {
        SetSaveData((prevValue) => {
          console.log("onServiceChange else prevValue :", prevValue);
          let s_index = prevValue.services.findIndex(
            (s_value) => s_value.id == item.id
          );
          prevValue.services.splice(s_index, 1);
          return { ...prevValue };
        });
      }
      return [...prevValue];
    });
  }

  function InputOnChange(item: any, index: any, value: any) {
    console.log("item :", item);
    console.log("index :", index);
    console.log("value :", value);
    service_data.map((item, sd_index) => {
      if (sd_index == index) {
        item.count_value = value;
      }
    });
    SetServiceData(service_data);
    SetSaveData((prevValue) => {
      console.log("prevValue :", prevValue);
      let s_index = prevValue.services.findIndex(
        (s_value) => s_value.id == item.id
      );
      console.log("s_index :", s_index);
      if (s_index != -1) {
        prevValue.services[s_index].quantity = value;
        return { ...prevValue };
      } else {
        return { ...prevValue };
      }
    });
  }

  function get_input_value(item: any, index: any) {
    console.log("get_input_value :");
    let r_value;
    let selected_service = props.data.record.services;
    if (selected_service != undefined) {
      for (var i = 0; i < selected_service.length; i++) {
        if (selected_service[i].service_id == item.id) {
          r_value = selected_service[i].quantity;
          break;
        } else {
          r_value = null;
        }
      }
      return r_value;
    }
  }

  async function save() {
    console.log("Form Value :", save_data);
    if (save_data.name != "") {
      let pass_data = {
        get: {
          brand: id_value.brand_id,
        },
        post: save_data,
      };
      let data = await api("/brand/edit_event", pass_data);
      console.log("api data :", data);

      if (data.status_code == 200) {
        console.log("/brand/edit_event status_code 200");
        console.log("myModal after:", myModal);
        let item = close_data;
        item.action = "edit";
        item.value = data.response.events[0];
        item.index = props.data.record_index;
        SetCloseData(item);
        SetSaveData(initial_value);
        myModal.hide();
      }
    }
  }

  function set_value(name: any, value: any) {
    validate(name, value);
    SetSaveData((oldValues) => ({ ...oldValues, [name]: value }));
  }

  function validate(name: any, value: any) {
    //A function to validate each input values
    console.log("name :", name);
    console.log("value  :", value);
    switch (name) {
      case "name":
        if (value.length <= 2) {
          // we will set the error state

          setErrors({
            ...errors,
            name: "Events name atleast have 3 letters",
          });
        } else {
          let newObj = omit(errors, "name");
          setErrors(newObj);
        }
        break;

      default:
        break;
    }
  }

  return (
    <div
      className="modal fade"
      id="ViewEventModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              {is_read_only ? "View Event" : "Edit Event"}
            </h5>
            <button
              type="button"
              className="btn-close"
              // data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <div className="mt-3">
                <form className="row g-3">
                  <div className="col-12">
                    <label className="form-label">Event Name</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      value={save_data.name}
                      onChange={(e) => {
                        set_value("name", e.target.value);
                      }}
                      readOnly={is_read_only}
                    />
                    {errors.name && (
                      <small className="text-red">{errors.name}</small>
                    )}
                  </div>
                  <p>Services</p>

                  {service_data.map((item, s_index) => (
                    <div className="form-check" key={s_index}>
                      <div className="row align-items-center">
                        <div className="col-5">
                          <label className="form-check-label d-flex">
                            <input
                              className="form-check me-2"
                              type="checkbox"
                              id="flexCheckDefault"
                              checked={item.checked}
                              onChange={() => {
                                onServiceChange(item, s_index);
                              }}
                              disabled={is_read_only}
                            />
                            {item.name}
                          </label>
                        </div>
                        {item.checked ? (
                          <div className="col-7">
                            <label className="v-small">
                              {item.quantity_type == 1
                                ? "Approximate Image Count "
                                : "Approximate Duration"}
                              <input
                                type="text"
                                name="role"
                                className="form-control"
                                placeholder={
                                  item.quantity_type == 1
                                    ? "No Of Image Count "
                                    : "No Of Min"
                                }
                                required
                                value={item.count_value}
                                onChange={(e) => {
                                  InputOnChange(item, s_index, e.target.value);
                                }}
                                readOnly={is_read_only}
                              />
                            </label>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ))}
                </form>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              // data-bs-dismiss="modal"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {!is_read_only ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={save}
              >
                Save
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
